export function ErrorCircle({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0.5C3.8675 0.5 0.5 3.8675 0.5 8C0.5 12.1325 3.8675 15.5 8 15.5C12.1325 15.5 15.5 12.1325 15.5 8C15.5 3.8675 12.1325 0.5 8 0.5ZM10.52 9.725C10.7375 9.9425 10.7375 10.3025 10.52 10.52C10.4075 10.6325 10.265 10.685 10.1225 10.685C9.98 10.685 9.8375 10.6325 9.725 10.52L8 8.795L6.275 10.52C6.1625 10.6325 6.02 10.685 5.8775 10.685C5.735 10.685 5.5925 10.6325 5.48 10.52C5.2625 10.3025 5.2625 9.9425 5.48 9.725L7.205 8L5.48 6.275C5.2625 6.0575 5.2625 5.6975 5.48 5.48C5.6975 5.2625 6.0575 5.2625 6.275 5.48L8 7.205L9.725 5.48C9.9425 5.2625 10.3025 5.2625 10.52 5.48C10.7375 5.6975 10.7375 6.0575 10.52 6.275L8.795 8L10.52 9.725Z"
          fill="#E74C3C"
        />
      </svg>
    </span>
  );
}
